import React from 'react';
import { Image, Platform, StatusBar, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { COLORS } from '../../theme/themeTokens';

interface SupportHeaderProps {
  title?: string;
  subtitle?: string;
  onBack?: () => void;
}

const SupportHeader: React.FC<SupportHeaderProps> = ({ title = 'Support', subtitle, onBack }) => (
  <View style={styles.container}>
    <StatusBar barStyle="light-content" backgroundColor={COLORS.primaryNavy} />
    <View style={styles.row}>
      {onBack ? (
        <TouchableOpacity
          style={styles.back}
          onPress={onBack}
          accessibilityRole="button"
          accessibilityLabel="Back">
          <Image source={require('../../assets/arrow_left_20_white.png')} style={styles.backIcon} />
        </TouchableOpacity>
      ) : <View style={styles.side} />}
      <View style={styles.titleWrap}>
        <Text style={styles.title} numberOfLines={1}>{title}</Text>
        {!!subtitle && <Text style={styles.subtitle} numberOfLines={1}>{subtitle}</Text>}
      </View>
      <View style={styles.side} />
    </View>
  </View>
);

const styles = StyleSheet.create({
  container: {
    backgroundColor: COLORS.primaryNavy,
    paddingTop: Platform.OS === 'android' ? 28 : 20,
  },
  row: {
    minHeight: 64,
    paddingHorizontal: 16,
    paddingBottom: 12,
    flexDirection: 'row',
    alignItems: 'center',
  },
  side: { width: 34 },
  back: { width: 34, height: 40, alignItems: 'flex-start', justifyContent: 'center' },
  backIcon: { width: 20, height: 20 },
  titleWrap: { flex: 1, alignItems: 'center' },
  title: { color: COLORS.white, fontSize: 18, fontWeight: '500' },
  subtitle: { color: COLORS.softGrey, fontSize: 12, marginTop: 2 },
});

export default SupportHeader;
